export enum LimitedFeatures {
	NiriCapture = 1,
	ScrewRetainCrown = 2,
	ProcedureFlow = 3,
	SleeveConfirmation = 4,
	ProcedureFlowReadOnly = 5
}
